import { Response } from "@/api/client";
import { useSnackbarStore } from "@/store/snackbar.store";

export function useError() {
  function showAPIError(response: Response<any>, defaultMessage = "") {
    const { showSnackbarError } = useSnackbarStore();

    let message = defaultMessage;
    const detail = response.errorData?.detail;

    if (Array.isArray(detail) && detail.length > 0) {
      message = detail[0]?.msg ?? defaultMessage;
    } else if (typeof detail === "string") {
      message = detail;
    }

    showSnackbarError(message);
  }

  return {
    showAPIError,
  };
}
